import React, { useEffect, useState } from 'react';
import { PngImages, SvgImages } from '../../Utils/LocalImages';
import Image from '../../Components/Reusable/Image';
import Sidebar from '../StudentSidebar/Sidebar';
import StudentNavbar from '../StudentNavbar/StudentNavbar';
import RoutesPath from '../../Utils/RoutesPath';
import { Link, useParams } from 'react-router-dom';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { handleApiErrors } from '../../Utils/Utils';
import { CirclesWithBar } from 'react-loader-spinner';
import generatePaginationFooter from '../../Components/Reusable/CustomPagination';
const Studymodules = () => {
    const { subject_id, medium } = useParams(); // Get package ID from the URL
    const [moduleDataId, setModuleDataId] = useState([]);
    const [medium1, setMedium] = useState('');
    const [subjectname, setSubjectName] = useState('');
    const [subjectId, setSubjectId] = useState('');
    const [loading, setLoading] = useState(true);
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(7);

    const moduleBackgroundOptions = [
        { backgroundColor: "#D6FFF8" },
        { backgroundColor: "#FFE4E4" },
        { backgroundColor: "#D4FFDF" },
        { backgroundColor: "#FFFDCB" },
        { backgroundColor: "#E9DEFF" },
    ];


    const getAllModuleByID = async (subject_id, medium) => {
        setLoading(true);

        try {
            const response = await StudentDashboardServices.getAllModuleByID(offset, limit, subject_id, medium);
            setModuleDataId(response.moduleList);
            setMedium(response.medium);
            setSubjectName(response.subject_name);
            setSubjectId(response.subject_id);
            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (subject_id) {
            getAllModuleByID(subject_id, medium);
        }
    }, [subject_id, medium, offset]);

    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">

                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black  fw-700 Header-student-text mb-0">Modules</h1>
                        <Link to={RoutesPath.studymaterials}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link>
                    </div>
                    <div className="mb-3 d-flex justify-content-between align-items-center">
                        <h1 className=" blue sub-large-text fw-700 mb-0">{subjectname}</h1>
                    </div>
                    <div className=' d-flex flex-column'>
                        {loading ? (
                            <div className="text-center d-flex justify-content-center">
                                <CirclesWithBar
                                    height="80"
                                    width="80"
                                    color="#F6821F"
                                    ariaLabel="bars-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>
                        ) :
                            moduleDataId.length > 0 ? (
                                moduleDataId.map((chapter, index) => {
                                    const backgroundData = moduleBackgroundOptions[index % moduleBackgroundOptions.length]; // Calculate background color dynamically

                                    return (
                                        <Link key={index} to={`${RoutesPath.studytopics}/${chapter.module_id}`}>
                                            <div style={{ backgroundColor: backgroundData.backgroundColor, padding: '16px', borderRadius: '10px', marginBottom: '20px' }}>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='d-flex flex-column gap-2'>
                                                        <h3 className='fw-500 small-medium-text blue mb-0'>Chapter {index + 1}:</h3>
                                                        <div>
                                                            <h3 className='sub-large-text-one fw-700 blue mb-0'>{chapter.module_name}</h3>
                                                        </div>
                                                    </div>
                                                    <div style={{ backgroundColor: 'white', borderRadius: '50px', width: '50px', height: '50px' }}>
                                                        <div className='d-flex justify-content-center' style={{ marginTop: '15px' }}>
                                                            <Image src={SvgImages.module_icon} style={{ height: 20 }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    );
                                })
                            ) : (
                                <div className="no-records-container text-center">
                                    <div className="no-record-image">
                                        <Image src={PngImages.no_record} className="img-fluid" />
                                    </div>
                                    <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
                                </div>
                            )}
                    </div>
                    <div className="row mt-3 align-items-center parentcustomnavbtn respo-pagination">
                        <div className="col-md-6 col-sm-6 col-12 ">     <p className=" small-text fw-500 mb-0" style={{ opacity: '0.5', fontStyle: "italic" }}>
                            {availableDataCount > 0
                                ? `Showing ${Math.min(offset * limit + 1, availableDataCount)} to ${Math.min((offset + 1) * limit, availableDataCount)} of ${availableDataCount} entries`
                                : "Showing No Entries"}</p>
                        </div>
                        <div className="col-md-6 col-sm-6 col-12">  {
                            generatePaginationFooter(
                                availableDataCount,
                                limit,
                                offset,
                                setOffset
                            )}</div>

                    </div>
                </div>
            </div>
        </div>


    );
};

export default Studymodules;
